import {
  ADD_QUOTATION,
  GET_QUOTATIONS,
  GET_QUOTATION,
  DELETE_QUOTATION,
  QUOTATION_ERROR,
  QUOTATION_LOADING,
} from "../types";
import customAxios from "../../utils/customAxios";
import moment from "moment";

// Statuses the customer My Page may list. UNSAVED quotations are admin-only
// work in progress (they have no quotationID yet), so they stay hidden there.
const CUSTOMER_VISIBLE_QUOTATION_STATUSES = "ACTIVE,EXPIRED,DRAFT";

// `params.status` / `params.paymentStatus` are comma-separated lists. The admin
// list passes them explicitly (an empty status means "every status"); callers
// that don't pass `status` get the customer-safe default above.
export const getQuotations = (params) => async (dispatch) => {
  try {
    dispatch({
      type: QUOTATION_LOADING,
    });

    const response = await customAxios.get("/api/admin/quotations", {
      params: {
        search: params.search,
        page: params.page,
        limit: params.limit,
        orderBy: params.orderBy,
        sortBy: params.sortBy,
        disableCalculateTotal: false,
        draw: 1,
        status: params.status ?? CUSTOMER_VISIBLE_QUOTATION_STATUSES,
        paymentStatus: params.paymentStatus || undefined,
        issueDateFrom: params.issueDateFrom || undefined,
        issueDateTo: params.issueDateTo || undefined,
        expiredDateFrom: params.expiredDateFrom || undefined,
        expiredDateTo: params.expiredDateTo || undefined,
      },
    });

    dispatch({
      type: GET_QUOTATIONS,
      payload: response.data.data,
    });
    // return response.data.data.data[0];
  } catch (error) {
    // dispatch({
    //   type: QUOTATION_ERROR,
    //   payload: { msg: error.response.statusText, status: error.response.status },
    // });
    console.error("Error fetching quotation:", error);
  }
}

export const fetchClients = async (query) => {
  try {
    const response = await customAxios.get("/api/users", {
      params: {
        limit: 10,
        search: query,
        page: 1,
        orderBy: "date",
        sortBy: "desc",
        disableCalculateTotal: true,
        draw: 1,
        role: "individual,business",
      },
    });
    return response
  } catch (error) {
    console.error("Error fetching clients:", error);
  }
};

export const postQuotation = async (data) => {
  try {
    const response = await customAxios.post("/api/admin/quotations", data);
    return response
  } catch (error) {
    console.log(error)
    if (error.response && error.response.data && error.response.data.errors) {
      const errorMessages = error.response.data.errors;
      throw new Error(errorMessages.join("\n")); // Throw a combined error message
    } else {
      throw new Error("An unexpected error occurred while add transfer.");
    }
  }
}

export const postEditQuotation = async (data, quotationId, bookingId) => {
  try {
    const response = await customAxios.post(`/api/admin/quotations/${quotationId}/booking/${bookingId}/edit`, data);
    return response
  } catch (error) {

    if (error.response && error.response.data && error.response.data.errors) {
      const errorMessages = error.response.data.errors;
      throw new Error(errorMessages.join("\n")); // Throw a combined error message
    } else {
      throw new Error("An unexpected error occurred while edit transfer.");
    }
  }
}

export const getDetails = async (id) => {
  try {
    const response = await customAxios.get("/api/admin/quotations/detail", {
      params: {
        search: "",
        page: 1,
        limit: 20,
        orderBy: "_id",
        sortBy: "asc",
        disableCalculateTotal: false,
        draw: "",
        id: id,
      },
    });
    return response.data.data.data[0];
  } catch (error) {
    console.error("Error fetching quotation:", error);

    return error.response ?? {
      message: error.message,
      status: 500,
    };
  }
}

export const getBookingType = (bookingType, isAirportTransfer) => {
  switch (bookingType) {
    case "byTheHour":
      return "By The Hour"
    case "specifiedDestination":
      if (isAirportTransfer) {
        return "Airport Transfer"
      } else {
        return "Specified Destination"
      }
    default:
      return "";
  }
}

export const formatTravelDate = (dateString) => {
  if (!dateString || dateString === "" || dateString === null) {
    return "";
  }
  const date = new Date(dateString);

  // Format bagian utama (bulan, hari, tahun)
  const options = { month: 'short', day: 'numeric', year: 'numeric' };
  const mainPart = new Intl.DateTimeFormat('en-US', options)
    .format(new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()))
    .replace(',', '.'); // Ganti koma dengan titik

  // Format hari dalam minggu (uppercase)
  const weekday = new Intl.DateTimeFormat('en-US', { weekday: 'short' })
    .format(date)
    .toUpperCase();

  return `${mainPart} (${weekday})`;
};

export const formatTime = (dateString) => {
  if (!dateString || dateString === "" || dateString === null) {
    return "";
  }
  const date = new Date(dateString);

  // Ambil jam dan menit dalam UTC
  const hours = date.getUTCHours().toString().padStart(2, '0'); // UTC hours
  const minutes = date.getUTCMinutes().toString().padStart(2, '0'); // UTC minutes

  return `${hours}:${minutes}`;
};

export const deleteTransfer = async (quotationId, bookingId) => {
  try {
    const response = await customAxios.post("/api/admin/quotations/delete-booking", {
      quotationId, bookingId
    });
    return response;
  } catch (error) {
    console.error("Error deleting booking:", error);
  }
}

export const activeQuotation = async (quotationId, quotationInformation, selectedUser, notes, status, bookingDiscounts = {}) => {
  try {

    var issueDate = moment
      .utc(quotationInformation.issueDate, "YYYY-MM-DD")
      .local()
      .format("YYYY-MM-DD")

    var validUntil = moment
      .utc(quotationInformation.validUntil, "YYYY-MM-DD")
      .local()
      .format("YYYY-MM-DD")

    // Per-transfer discounts: [{ bookingId, discount }] for every transfer with a rate > 0.
    const bookingDiscountList = Object.entries(bookingDiscounts || {})
      .map(([bookingId, rate]) => ({ bookingId, discount: Number(rate) }))
      .filter((entry) => entry.discount > 0);

    const response = await customAxios.post("/api/admin/quotations/activate", {
      "id": quotationId,
      "quotationID": quotationInformation.quotationId,
      "quotationNumber": quotationInformation.bookingReference,
      "issueDate": new Date(`${issueDate}T00:00:00Z`),
      "expiredDate": new Date(`${validUntil}T00:00:00Z`),
      "user": selectedUser._id,
      "notes": notes ?? "",
      "bookingDiscounts": bookingDiscountList,
      "status": status
    });
    return response;
  } catch (error) {
    if (error.response && error.response.data && error.response.data.errors) {
      const errorMessages = error.response.data.errors;
      throw new Error(errorMessages); // Throw a combined error message
    } else {
      throw new Error("An unexpected error occurred while activating the quotation.");
    }
  }
}

// Bring an EXPIRED quotation back to ACTIVE with a new valid-until date. Unlike
// activeQuotation this touches nothing but the status and the date, so the
// stored transfers, items and discounts are left exactly as the customer saw them.
// Saves how the transfers of a quotation are ordered ("travelDate" or "addedAt").
// Resolves to { bookingSortOrder, sortedBookingIds }.
export const saveBookingSortOrder = async (quotationId, bookingSortOrder) => {
  try {
    const response = await customAxios.post("/api/admin/quotations/booking-sort-order", {
      quotationId,
      bookingSortOrder,
    });
    return response.data;
  } catch (error) {
    const errors = error.response?.data?.errors;
    if (errors) {
      throw new Error(Array.isArray(errors) ? errors.map((e) => e.msg).join(", ") : errors);
    }
    throw new Error("An unexpected error occurred while saving the transfer order.");
  }
}

export const reactivateQuotation = async (quotationId, issueDate, expiryDate) => {
  try {
    const toUTCMidnight = (date) =>
      new Date(`${moment.utc(date, "YYYY-MM-DD").local().format("YYYY-MM-DD")}T00:00:00Z`);

    const response = await customAxios.post("/api/admin/quotations/reactivate", {
      "id": quotationId,
      "issueDate": toUTCMidnight(issueDate),
      "expiredDate": toUTCMidnight(expiryDate),
    });
    return response.data;
  } catch (error) {
    const errors = error.response?.data?.errors;
    if (errors) {
      throw new Error(Array.isArray(errors) ? errors.map((e) => e.msg).join(", ") : errors);
    }
    throw new Error("An unexpected error occurred while reactivating the quotation.");
  }
}

// Expire an ACTIVE quotation right now, before its expiry date. The customer link
// stops accepting payment immediately; the admin can undo it with
// reactivateQuotation.
export const expireQuotation = async (quotationId) => {
  try {
    const response = await customAxios.post("/api/admin/quotations/expire", {
      "id": quotationId,
    });
    return response.data;
  } catch (error) {
    const errors = error.response?.data?.errors;
    if (errors) {
      throw new Error(Array.isArray(errors) ? errors.map((e) => e.msg).join(", ") : errors);
    }
    throw new Error("An unexpected error occurred while expiring the quotation.");
  }
}

export const addUser = async (formData) => {
  try {
    const response = await customAxios.post("/api/users/register-guest-quotation", {
      name: formData.name,
      email: formData.email,
      phone: formData.phoneNumber,
      country: formData.country,
      pronounced: formData.honorific,
      prefixNumber: formData.prefixNumber,
      countryCode: formData.countryCode,
      postCode: formData.postalCode,
      address: formData.billingAddress,
      city: formData.city,
      type: formData.type
    });
    return response;
  } catch (error) {
    console.error("Error add user:", error);
    throw error;
  }
}

// Turns an axios error from the quotation-client endpoints into a sentence the
// admin can read ("Name is required"), never a raw error object.
const getQuotationClientErrorMessage = (error, fallbackMessage) => {
  const errors = error?.response?.data?.errors;
  if (Array.isArray(errors) && errors.length > 0) return errors[0].msg || fallbackMessage;
  if (errors?.msg) return errors.msg;
  if (typeof errors === "string") return errors;
  return fallbackMessage;
};

// Asks the backend what else editing this client would change: other
// quotations of the same user, and whether the user has a website account.
// Resolves to { requiresConfirmation, isRegisteredAccount, accountType,
// otherQuotationCount, otherQuotations[], existingBookingCount }.
export const fetchQuotationClientImpact = async (userId, quotationId) => {
  try {
    const response = await customAxios.get(`/api/admin/quotations/client/${userId}/impact`, {
      params: quotationId ? { quotationId } : {},
    });
    const clientImpact = response?.data?.clientImpact;
    if (!clientImpact || typeof clientImpact.requiresConfirmation !== "boolean") {
      throw new Error("Unexpected response while checking the client.");
    }
    return clientImpact;
  } catch (error) {
    throw new Error(
      getQuotationClientErrorMessage(error, "Could not check where this client is used. Please try again.")
    );
  }
};

// Admin edit of a quotation client (guest or registered user), by user id.
export const updateQuotationClient = async (userId, formData) => {
  try {
    const response = await customAxios.post(`/api/admin/quotations/client/${userId}`, {
      name: formData.name,
      phone: formData.phoneNumber,
      country: formData.country,
      pronounced: formData.honorific,
      prefixNumber: formData.prefixNumber,
      countryCode: formData.countryCode,
      postCode: formData.postalCode,
      address: formData.billingAddress,
      city: formData.city,
    });
    if (!response?.data?.user?._id) {
      throw new Error("Unexpected response while saving the client.");
    }
    return response.data.user;
  } catch (error) {
    throw new Error(getQuotationClientErrorMessage(error, error?.message || "Failed to update client!"));
  }
};

export const updateUserGuestQuotation = async (formData) => {
  try {
    const response = await customAxios.post("/api/users/update-guest-info", {
      name: formData.name,
      email: formData.email,
      phone: formData.phoneNumber,
      country: formData.country,
      pronounced: formData.honorific,
      prefixNumber: formData.prefixNumber,
      countryCode: formData.countryCode,
      postCode: formData.postalCode,
      address: formData.billingAddress,
      city: formData.city
    });
    return response;
  } catch (error) {
    console.error("Error add user:", error);
    throw error;
  }
}

export const formatPaxData = (data) => {
  if (!data) {
    return "";
  }
  const filteredData = data.filter(item => item.paxcount > 0);

  return filteredData.map(item => `${item.paxtype}: ${item.paxcount}`).join(', ');
}

export const formatLuggageData = (data) => {

  if (!data) {
    return "";
  }
  const filteredData = data.filter(item => item.luggagecount > 0);

  if (filteredData.length === 0) {
    return "None";
  }

  const typeMapping = {
    "CHECK-IN SIZE": "Check-in",
    "CABIN SIZE": "Cabin"
  };

  // Format menjadi string
  return filteredData
    .map(item => `${typeMapping[item.luggagetype] || item.luggagetype}: ${item.luggagecount}`)
    .join(', ');
}

export const formatChildSeatData = (data) => {

  if (!data) {
    return "";
  }
  const filteredData = data.filter(item => item.childSeatCount > 0);

  if (filteredData.length === 0) {
    return "None";
  }

  return filteredData
    .map(item => `${item.childSeatType} Seat: ${item.childSeatCount}`)
    .join(', ');
}

export const getMeetAssistNames = (data) => {
  if (!data) {
    return "";
  }
  return data
    .filter(item => item.type === "meetAssistArrival" || item.type === "meetAssistDeparture")
    .map(item => item.name)
    .join(', ');
}

export const paymentEligibility = async (id) => {
  try {
    console.log(id);

    const response = await customAxios.post("/api/admin/quotations/payment-eligibility", {
      "id": id,
    });

    return response.data;
  } catch (error) {
    console.error("Error deleting booking:", error);
  }
}

export const finishPayment = async (reqBody) => {
  try {
    const response = await customAxios.post("/api/admin/quotations/finish-payment",
      reqBody
    );

    return response.data;
  } catch (error) {
    console.error("Error deleting booking:", error);
  }
}

export const duplicateBooking = async (reqBody) => {
  try {
    const response = await customAxios.post("/api/admin/quotations/duplicate-booking",
      reqBody
    );

    return response.data;
  } catch (error) {
    console.error("Error deleting booking:", error);
    throw error;
  }
}

export const addQuotationItems = async (reqBody) => {
  try {
    const response = await customAxios.post("/api/admin/quotations/add-item", reqBody);
    return response.data;
  } catch (error) {
    console.error("Error add quotation items:", error);
    throw error;
  }
}

export const removeAllItems = async (reqBody) => {
  try {
    const response = await customAxios.post("/api/admin/quotations/remove-all-items", reqBody);
    return response.data;
  } catch (error) {
    console.error("Error removing all quotation items:", error);
    throw error;
  }
}

export const createEmptyQuotation = async (data) => {
  try {
    const response = await customAxios.post("/api/admin/quotations/create-empty", data);
    return response.data;
  } catch (error) {
    console.error("Error creating empty quotation:", error);
    throw error;
  }
}

export const createAndActivateQuotation = async (data) => {
  try {
    const response = await customAxios.post("/api/admin/quotations/create-and-activate", data);
    return response.data;
  } catch (error) {
    if (error.response?.data?.errors) {
      throw new Error(error.response.data.errors);
    }
    throw new Error("An unexpected error occurred while creating the quotation.");
  }
}

export const addStandaloneItems = async (reqBody) => {
  try {
    const response = await customAxios.post("/api/admin/quotations/add-standalone-items", reqBody);
    return response.data;
  } catch (error) {
    console.error("Error adding standalone items:", error);
    throw error;
  }
}

export const removeStandaloneItems = async (reqBody) => {
  try {
    const response = await customAxios.post("/api/admin/quotations/remove-standalone-items", reqBody);
    return response.data;
  } catch (error) {
    console.error("Error removing standalone items:", error);
    throw error;
  }
}

export const chargeQuotation = async (quotationId) => {
  try {
    const response = await customAxios.post("/api/flywire/charge-quotation", { quotationId });
    return response.data;
  } catch (error) {
    console.error("Error charging quotation:", error);
    throw error;
  }
}
